import { ILanguage } from '../../interfaces/ILanguage'

export const sv: ILanguage = {
   AppHeader: '365 Back office',
   SignIn: 'Logga in',
   SignOut: 'Logga ut',
   WelcomeTo: 'Välkommen till',

   Title: 'Titel',
   Status: 'Status',
   RelevanceStatus: 'Hanteringsstatus',
   ID: 'ID',
   SfsNo: 'SFS Nr',
   Department: 'Departement/Myndighet',
   IssuedAt: 'Utfärdad',
   ModifiedAt: 'Ändrad',
   ModificationRegister: 'Ändringsregister',
   Source: 'Källa',
   Content: 'Innehåll',

   ShowLawsWithStatusNo: 'Visa lagar med status "Nej"',
   Number: 'Nummer',
   Subject: 'Ämne',
   LeadershipPerspective: 'Ledningsperspektiv',
   NumberOfLaws: 'Antal lagar',
   Modified: 'Senast ändrad',
   ModifiedBy: 'Senast ändrad av',
   NewDemand: 'Nytt krav',
   ChoosenDemands: 'Utvalda krav',
   ChoosenDemandsInfo: 'Detta är de krav som är valda och skapta. Det är dessa som kommer speglas i 365 Robust. Under fliken "Lagar" kan du ta in fler lagar',
   WebLink: 'Webblänk',
   Description: 'Beskrivning',
   ChooseParagraphsInfo: 'Välj de paragrafer som ska bli krav',
   ClearDemand: 'Rensa pågående kravhantering',
   ClearDemandText: 'Är du säker på att du vill rensa den pågående kravhanteringen? Detta raderar data och återställer statusen. Det går ej att ångra',
   QuestionWillBeDeletedOnContinue:
      'Denna fråga kommer att raderas om du klickar på fortsätt. Vänligen spara frågan innan du byter fråga ifall att du vill spara den.',

   //User Message Bar
   LawWithStatusNoCantBeHandled: 'Lagen har hanteringsstatus "Nej"',
   ChangeStatusToHandleLaw: 'Ändra hanteringsstatus för att kunna bearbeta lagen.',
   LawHasBeenSentToDemandList: 'Lagen har skickats till krav- och frågelistan',
   LawCantBeEdited: 'Ingen hantering ska kunna ske',
   LawHasBeenUpdatedSinceLastUpdate: 'Lagen har UPPDATERATS sedan senaste hantering',
   ChangeStatusToUpdateImportStatus: 'Ändra hanteringsstatus eller välj "Behåll hanteringsstatus" för att uppdatera importstatusen.',
   LawIsUpdated: 'Lagen är uppdaterad',
   PleaseReviewDemands: 'Vänligen granska kraven.',
   NoResultByFilter: 'Inga resultat hittades för de valda filtren.',
   NoOrganisationsFound: 'Inga kunder kunde hittas.',
   AdjustFilterToFindWhatYoureLookingFor: 'Prova att justera filtren för att hitta det du söker',
   NoLawSearchResults: 'Inga lagar matchar din sökning',
   AddFirstCustomerMsg: 'Lägg till din första kund för att komma igång med 365 Robust.',

   // Nav
   Dashboard: 'Dashboard',
   Home: 'Hem',
   CustomerRegister: 'Kundregister',
   DemandQuestionList: 'Krav- och frågelista',
   LawsImport: 'Import av lagar',
   KnowledgeBankFormCustomer: 'Kunskapsbank för kund',
   SystemSettings: 'Systeminställningar',

   // Status
   Yes: 'Ja',
   No: 'Nej',
   Maybe: 'Kanske',
   Demand: 'Krav',
   OngoingDemand: 'Pågående krav',
   Updated: 'Uppdaterad',
   Revoked: 'Upphävd',
   New: 'Ny',
   All: 'Alla',
   Empty: '(Tom)',
   Unhandled: 'Ej hanterad',
   Definite: 'Fastställd',
   Ongoing: 'Pågående',
   Reviewing: 'Revideras',
   Resting: 'Vilande',
   Archived: 'Arkiverad',
   SavedButNotSure: '',
   Archive: 'Arkivera',

   // Billing
   BillingData: 'Fakturauppgifter',
   InvoiceReference: 'Fakturareferens',
   InvoiceAddress: 'Fakturaadress',
   PostalCode: 'Postnummer',
   County: 'Postort',
   PhoneNumber: 'Telefonnummer',
   Email: 'E-post',
   OtherInvoiceDetails: 'Övriga fakturauppgifter',

   // Laws
   ImportedLaws: 'Importerade lagar',

   // Demand
   SubType: 'Underkravtyp',
   EUDirective: 'EU-förordning',
   Law: 'Lag',
   Paragraph: 'Paragraf',
   ISOStandard: 'ISO standard',
   Ordinance: 'Förordning', // Förordning
   Regulation: 'Föreskrift', // Föreskrift
   GeneralAdvice: 'Allmänt råd',
   Guidance: 'Vägledning',
   DemandElement: 'Kravelement',
   OtherDemands: 'Övriga krav',
   Article: 'Artikel',
   DemandType: 'Kravtyp',
   Origin: 'Ursprung',
   Sweden: 'Sverige',
   DemandLevel: 'Kravnivå',
   PublicAuthorityDemand: 'Myndighetskrav',
   InsuranceDemand: 'Försäkringskrav',
   IndustryDemand: 'Branschkrav',
   GodPraxis: 'God praxis',
   DemandArea: 'Kravområde',
   Economy: 'Ekonomi',
   Market: 'Marknad',
   WorkEnviroment: 'Arbetsmiljö',
   Management: 'Ledning',
   ITLaw: 'IT-säkerhet',
   Production: 'Produktion',
   Environment: 'Miljö',
   Staff: 'Personal',
   Security: 'Säkerhet',
   StatusImport: 'Importstatus',
   Question: 'Fråga',
   DemandText: 'Kravtext',
   AnswerType: 'Svarsform',
   DemandSource: 'Kravkälla',
   AllDemands: 'Alla krav',
   UrlText: 'Webbtext',
   NewSubDemand: 'Nytt underkrav',
   ParentDemand: 'Överkrav',
   SubDemands: 'Underkrav',
   DemandArchiveWarningText: 'Är du säker på att du vill arkivera detta krav med underliggande information?',
   DemandDeleteWarningText: 'Är du säker på att du vill radera detta krav?',
   ArchivedDemands: 'Arkiverade krav',
   Activate: 'Aktivera',
   DemandActivateWarningText: 'Är du säker på att du vill aktivera detta krav och underliggande information igen?',
   ActiveDemands: 'Aktiva krav',
   ActiveQuestions: 'Aktiva frågor',
   ImportedDemands: 'Importerade krav',
   Version: 'Version',
   NoArchivedDemands: 'Det finns inga arkiverade krav',
   ShowMore: 'Visa fler',
   ShowLess: 'Visa färre',
   of: 'av',
   EnterURL: 'Ange URL',
   BulletList: 'Punktlista',
   NumberedList: 'Numrerad lista',
   LetteredList: 'Bokstavslista',
   UpperLetteredList: 'Versal bokstavslista',
   IncreaseIndent: 'Öka indrag',
   DecreaseIndent: 'Minska indrag',
   LawDemandIsBasedOnHasChanged: 'Lagen detta krav baseras på har ändrats',
   AcknowledgeChange: 'Tagit del av ändring',
   ChooseParentDemand: 'Välj överkrav',
   NewParentDemand: 'Nytt överkrav',
   SetParentDemand: 'Sätt överkrav',

   // Validation
   Warning: 'Varning',
   SendToDemandList: 'Skicka till kravlista',
   Save: 'Spara',
   Cancel: 'Avbryt',
   Clear: 'Rensa',
   Undo: 'Ångra',
   Delete: 'Radera',
   Confirm: 'Bekräfta',
   SavedSuccess: 'Sparning lyckad',
   SavedError: 'Sparningen misslyckades',
   SavedDemands: 'Kraven är sparade',
   DemandsSent: 'Kraven är skickade till kravlistan',
   DemandMoveError: 'Misslyckades med att flytta krav',
   DemandFetchError: 'Misslyckades med att hämta krav',
   QuestionSaved: 'Frågan är sparad',
   DemandSuccessfullyCleared: 'Den pågående kravhanteringen är rensad och nollställd',
   DemandClearingFailed: 'Något gick fel när den pågående kravhanteringen skulle rensas och nollställas',
   RequiredField: 'Vänligen, fyll i detta fält',
   UndoDemandChanges: 'Vill du ångra dina ändringar för detta krav?',
   SaveBeforeProceed: 'Spara dina ändringar innan du fortsätter',
   FormHasUnsavedChanges: 'Formuläret har osparade ändringar. Vänligen, spara ändringarna innan du fortsätter',
   LatestChangesWillBeUndone: 'Ändringarna återställs.',
   AreYouSureLatestChangesWillBeUndone:
      'Är du säker på att du vill fortsätta? Dina senaste ändringar kommer att återställas. Om du vill spara dina ändringar, vänligen klicka på avbryt och spara formuläret innan du fortsätter',
   UndoQuestionChanges: 'Vill du ångra dina ändringar i denna fråga?',
   AreYouSureDeleteOrganisation: 'All relaterad data kommer också att raderas och går inte att återställa.',
   UndoChanges: 'Ångra ändringar',
   Continue: 'Fortsätt',
   FetchFailed: 'Hämtning misslyckades',
   ItemDeleted: 'Objektet raderades framgångsrikt',
   DeleteError: 'Objektet kunde inte raderas',
   DeleteAttachment: 'Radera bilaga',
   CantChangeParentByDND: 'Du kan inte tilldela kravet en ny förälder genom drag and drop',
   CantDNDOnArchived: 'Du kan inte ändra ordningen på arkiverade krav',
   CantChangeParentOrLevelByDND: 'Du kan inte tilldela kravet en ny förälder eller nivå genom drag and drop',
   ActionNotSupported: 'Återgärden stöds inte',
   CouldNotFetchQuestions: 'Något gick fel vid hämtningen av frågor',
   CouldNotFetchLaw: 'Något gick fel i hämtningen av lagen',
   CouldNotFetchLaws: 'Det gick inte att ladda listan med lagar. Försök igen senare.',
   LawDoesNotContainParagraphs: 'Lagen innehåller inga paragrafer.',
   ParagraphsCouldNotBeFetched: 'Inga paragrafer kunde hämtas in.',
   QuestionDeleted: 'Frågan är raderad',
   CouldNotAcknowledgeChange: 'Kunde inte bekräfta att du tagit del av ändring i lag ',
   CouldNotFetchDemand: 'Något gick fel i hämtningen av kravet',
   CouldNotFetchOrganisations: 'Något gick fel i hämtningen av organisationer',
   CouldNotDeleteOrganisation: 'Något gick fel vid raderingen av organisationen',
   CouldNotCreateOrganisation: 'Något gick fel vid skapandet av organisationen',
   CouldNotUpdateOrganisation: 'Något gick fel vid uppdateringen av organisationen',
   CouldNotDownloadContract: 'Något gick fel vid nedladdningen av avtalet',
   ConfirmAcknowledgeChange: 'Bekräfta att du tagit del av ändring',
   ConfirmAcknowledgeChangeText: 'Importstatusen nollställs och meddelandet om ändringar i lagen kommer att försvinna. Detta gäller lagen med sfs nummer: ',
   CouldntExpandRow: 'Kunde inte expandera rad',
   LawStatusError: 'Det gick inte att uppdatera lagens status',
   LawUpdated: 'Lagen uppdaterades!',
   ReviewPerformed: 'Granskning utförd!',
   SomethingWentWrong: 'Något gick fel',
   CouldntFetchDashboardData: 'Kunde inte hämta dashboard data',

   // Error page (fallback när något kastar under rendering)
   ErrorNotFoundTitle: 'Sidan kunde inte hittas',
   ErrorBadRequestMessage: 'Informationen kunde inte behandlas. Kontrollera uppgifterna och försök igen.',
   ErrorSessionExpiredMessage: 'Din session har gått ut. Logga in igen för att fortsätta.',
   ErrorForbiddenMessage: 'Du har inte behörighet att se den här informationen.',
   ErrorNotFoundMessage: 'Vi kunde inte hitta det du letade efter. Sidan kan ha flyttats eller tagits bort.',
   ErrorConflictMessage: 'Informationen har ändrats av någon annan. Ladda om sidan och försök igen.',
   ErrorTimeoutMessage: 'Det tog för lång tid att få svar från tjänsten. Försök igen om en stund.',
   ErrorServerMessage: 'Ett fel uppstod i tjänsten. Felet har loggats — försök igen om en stund.',
   ErrorNetworkMessage: 'Vi kunde inte nå tjänsten. Kontrollera din internetanslutning och försök igen.',
   ErrorUnexpectedMessage: 'Ett oväntat fel inträffade. Du kan försöka igen eller gå tillbaka till startsidan.',
   ErrorContactSupport: 'Om felet återkommer, kontakta supporten och uppge informationen nedan.',
   ErrorOccurredAt: 'Tidpunkt',
   ReferenceId: 'Referens',
   ReloadPage: 'Ladda om sidan',
   GoToStartPage: 'Till startsidan',
   ShowTechnicalDetails: 'Visa teknisk information',
   CopyErrorDetails: 'Kopiera felinformation',
   CopiedToClipboard: 'Kopierat',
   CouldNotSendWelcomeMail: 'Kunde inte skicka välkomstmail',
   CouldNotSendSubscriptionUpdateMail: 'Kunde inte skicka mail till användare om abonnemangsändring',
   DNDSuccess: 'Kraven har bytt ordning',
   DNDFail: 'Det gick inte att byta ordning på kraven',
   OrganisationDeleted: 'Kunden raderades',
   OrganisationCreated: 'Kunden skapades',
   OrganisationUpdated: 'Kunden uppdaterades',
   SandboxUpdated: 'Sandboxen uppdaterades',
   CouldNotUpdateSandbox: 'Kunde inte uppdatera sandboxen',
   InvalidEmailAddress: 'Ogiltig e-postadress',
   PersonalNumberMustBe12Digits: 'Personnummer måste vara 12 siffror (ÅÅÅÅMMDD-XXXX)',
   PersonalNumberMustBeUnique: 'En användare med detta personnummer finns redan',
   PersonalNumberMustBeNumbersOnly: 'Personnummer får endast bestå av siffror',

   // Question
   QuestionsForDemand: 'Frågor till krav',
   NewQuestion: 'Ny fråga',
   BackgroundInformation: 'Bakgrundsfakta',
   ProposedAction: '365Robust tipsar',
   OrganisationType: 'Organisationsform',
   OrganisationSize: 'Organisationsstorlek',
   Process: 'Process',
   AlternativeProcesses: 'Alternativa processer',
   SNI: 'SNI',
   SNI2007: 'SNI 2007',
   SNI2025: 'SNI 2025',
   AdditionalModules: 'Tilläggsmoduler',
   AdditionalModulesDepreciated: 'Tilläggsmoduler (föråldrad)',
   Subscription: 'Abonnemang',
   Attachment: 'Bilaga',
   AddFile: 'Lägg till fil',
   NoQuestionsCreated: 'Det finns inga frågor kopplat till detta krav',
   NoQuestionChosen: 'Välj en fråga för att se innehållet',
   DeleteAttachmentText: 'Är du säker på att du vill radera bilagan?',
   QuestionWithCombinationAlreadyExists: 'En fråga med denna kombination av värden finns redan',
   ShowQuestion: 'Se fråga',
   LoadingQuestions: 'Hämtar frågor',
   Subscriptions: 'Abonnemang',

   //AnswerOptions
   YesNo: 'Ja/Nej',
   YesNoDontKnow: 'Ja/Nej/Vet inte',
   Compliance: 'Efterlevnad',
   OwnAnswers: 'Egna svar',
   AddAnswerOption: 'Lägg till svarsalternativ',
   AnswerOption: 'Svarsalternativ',
   Info: 'Info',
   Value: 'Värde',
   DemandConnection: 'Koppla krav',
   UndoAnswerOptionChanges: 'Vill du ångra dina ändringar för detta svarsalternativ?',
   Catalog: 'Katalog',
   AnswerOptionList: 'Lista för svarsalternativ',
   Order: 'Ordning',
   CreateNewAnswerOption: 'Nytt svarsalternativ',
   ConnectDemandToAnswer: 'Ska man kunna koppla krav till detta svarsalternativ?',
   SelectAnAnswerOption: 'Välj ett svarsalternativ',
   SelectAnOption: 'Gör ett val',
   SelectOneOrMoreOptions: 'Gör ett eller flera val',
   DeleteDemandConnection: 'Ta bort kravkoppling',
   ExportedSuccess: 'Export lyckades',
   ExportFail: 'Exporting failed',
   ExportingDemandsAndQuestions: 'Exporterar krav och frågor',
   PreparingExcel: 'Förbereder excel',
   FetchingDemands: 'Hämtar krav',
   FetchingQuestions: 'Hämtar frågor',
   GeneratingExcel: 'Genererar excel',
   ChangedTo: 'Ändrad till',

   // DemandComplianceModuleDefinition
   DemandComplianceModules: 'Kravefterlevnadsmoduler',
   DemandComplianceAdditionalModules: 'Kravefterlevnad tilläggsmoduler',
   CreateNewDemandComplianceModule: 'Skapa ny kravefterlevnad tilläggsmodul',
   UndoDemandComplianceModuleChanges: 'Vill du ångra dina ändringar på denna kravefterlevnad tilläggsmodul?',
   Name: 'Namn',
   Active: 'Aktiv',

   // Clauses
   Division: 'Indelning',
   MainNumber: 'Huvudnummer',
   SubNumber: 'Undernummer',
   Clause: 'Indelning',
   Clauses: 'Indelningar',
   AddClause: 'Lägg till indelning',
   EditClause: 'Redigera indelning',

   // Organisation
   OrganisationNumber: 'Organisationsnummer',
   CompanyName: 'Företagsnamn',
   DeleteOrganisation: 'Radera kund',
   OrganisationDetails: 'Organisationsuppgifter',
   AmountOfWorkPlaces: 'Antal arbetsställen',
   User: 'Användare',
   OrganisationContractFileName: 'Kundavtal',
   OrganisationNumberMustBe10Digits: 'Organisationsnummer måste vara 10 siffror (XXXXXX-XXXX)',
   OrganisationNumberAlreadyRegistered: 'Organisationsnummer finns redan registrerat',
   ZipNumberMustBe5Digits: 'Postnummer måste vara 5 siffror (XXX XX)',
   PhoneNumberMustBe10Digits: 'Telefonnummer måste vara 10 siffror (XXX XXX XX XX)',
   AtleastOneSystemAdminRequired: 'Minst en systemadministratör krävs',
   ContractIsCreatedAndDownloaded: 'Avtalet är skapat och nedladdat',
   Send: 'Skicka',
   SendWelcomeEmail: 'Skicka välkomstmail',
   WelcomeEmail: 'Välkomstmail',
   WelcomeEmailNotSent: 'Ej skickat',
   SendWelcomeEmailAgain: 'Skicka om välkomstmail',
   WelcomeEmailAlreadySent: 'Välkomstmailet skickades redan',
   SaveBeforeSendingWelcomeEmail: 'Spara ändringarna innan du skickar',
   WelcomeEmailSentPreviously: 'Skickat tidigare',
   WelcomeEmailSentAt: 'Skickat',
   SendWelcomeEmailConfirmation: 'Välkomstmailet skickas till:',
   NoRecipientsForWelcomeEmail: 'Kunden saknar användarkonton att skicka till',
   CouldNotFetchWelcomeEmailStatus: 'Kunde inte hämta status för välkomstmail',
   WelcomeEmailSent: 'Välkomstmail skickat',
   UpdateSubscriptionEmailSent: 'Uppdateringsmail om abonnemang skickat',
   MailWasSentTo: 'Mailet skickades till',
   Sandbox: 'Sandbox',
   Sandboxes: 'Sandboxar',
   Partner: 'Partner',
   AddSandbox: 'Lägg till sandbox',
   AnAccountMustBeSelected: 'Vänligen välj ett konto',

   // User
   AccountInformation: 'Användaruppgifter',
   Account: 'Konto',
   FirstName: 'Förnamn',
   LastName: 'Efternamn',
   OrganizationalAffiliation: 'Organisationstillhörighet',
   JobTitle: 'Jobbtitel',
   UserType: 'Användartyp',
   Roles: 'Roller',
   PersonalNumber: 'Personnummer',
   PersonalNumberFormat: 'ÅÅÅÅMMDD-XXXX',

   //Labels / Placeholders
   Search: 'Sök',
   Designation: 'Benämning',
   ExpandAll: 'Expandera vy',
   MiniMizeAll: 'Minimera',
   SortOnColumn: 'Sortera på kolumn',
   FilterOnProcessStatus: 'Filtrera på hanteringsstatus',
   FilterOnImportStatus: 'Filtrera på importstatus',
   LawsWithFilter: 'lagar med filtrering',
   LawsWithoutFilter: 'lagar utan filtrering',
   SearchLaws: 'Sök på titel eller SFS-nummer',
   SearchMinLengthHint: 'Skriv minst två tecken för att söka',
   Valuation: 'Värdering',
   SubscriptionsAndAdditionalModules: 'Abonnemang och tilläggsmoduler',
   ConfirmUncheck: 'Bekräfta borttagning av partnerstatus',
   ConfirmDeleteUser: 'Bekräfta borttagning av användare',

   //Modal header / Modal content
   MoveDemand: 'Flytta krav',
   MoveTargetTo: 'Flytta till...',
   DemandModalSearchParams: 'Sök efter ID, webbtext eller benämning',
   EmptySearchResult: 'Inga krav matchar det angivna sökkriteriet...',
   NoSearchResultsTitle: 'Inga träffar',
   NoSearchResults: 'Inga krav eller frågor matchar din sökning',
   SearchDemandsAndQuestions: 'Sök krav och frågor – ID, benämning, text, typ, källa',
   SearchingAllTabs: 'Sökningen omfattar alla flikar – aktiva krav, frågor och arkiverade krav',
   ClearSearch: 'Rensa sökning',
   SearchHitsDemand: 'krav',
   SearchHitsDemands: 'krav',
   SearchHitsQuestion: 'fråga',
   SearchHitsQuestions: 'frågor',
   SearchResultsTruncated: 'Förfina sökningen – visar bara de första',
   OfTotalHits: 'träffarna av',
   ExportDisabledDuringSearch: 'Rensa sökningen för att exportera',
   SearchDisabledDuringFastMove: 'Avbryt snabbflytten för att söka',
   FastMoveDisabledDuringSearch: 'Rensa sökningen för att snabbflytta',
   SearchForLevelOneDemands: 'Sök efter nivå 1 krav',
   SearchForLevelTwoDemands: 'Sök efter nivå 2 krav',
   ChangeOrder: 'Byt ordning',

   //Buttons
   FastMoveDemand: 'Snabbflytta krav',
   AbortFastMove: 'Avbryt snabbflytt',
   MoveTo: 'Flytta till',
   Move: 'Flytta',
   ExportDemandsAndQuestionsToExcel: 'Exportera till excel',
   ResetFilter: 'Återställ filtrering',
   Previous: 'Föregående',
   Next: 'Nästa',
   DemandsHaveBeenReviwed: 'Tagit del av alla krav',
   KeepRelevanceStatus: 'Behåll hanteringsstatus',
   NewCustomer: 'Ny kund',
   EditCustomer: 'Ändra kunduppgifter',
   AddUser: 'Lägg till användare',
   SaveAndClose: 'Spara & stäng',
   Create: 'Skapa',
   CreateNew: 'Skapa ny',
   DeleteSandboxes: 'Radera sandboxar',
   UpgradeToOrganisation: 'Uppgradera till organisation',
   DeleteUser: 'Radera användare',

   // Dashboard
   Welcome: 'Välkommen',
   OngoingActivities: 'Pågående aktiviteter',
   Activity: 'Aktiviteter',
   StatusLaws: 'Status lagar',
   LatestUpdate: 'Senaste uppdatering',
   NumberOfCustomers: 'Antal kunder',
   NumberOfQuestions: 'Antal frågor',
   new: 'nya',
   revoked: 'upphävda',
   updated: 'uppdaterade',
   Changed: 'Förändrat',

   // Information texts
   NoAnswerOptions: 'Det finns inga svarsalternativ. För att skapa svarsalternativ, gå till',
   NoAnswerOptionsLink: 'Systeminställningar -> Svarsalternativ',
   DeleteConfirmationMsg: 'Är du säker på att du vill radera',
   ConfirmUncheckMsg:
      'Är du säker på att du vill ta bort organisationens partnerstatus? Alla tillhörande sandboxar kommer att raderas permanent om du fortsätter.',
   ConfirmDeleteUserMsg: 'Är du säker på att du vill ta bort användaren?',
   GoodPracticeCantBeDeleted: 'God praxis modulen är en system-skapad modul och går ej att radera.',

   // Modules
   Modules: 'Moduler',
   BaseModules: 'Grundmoduler',
   Processes: 'Processer',
   StrategicDemandAssessment: 'Strategisk kravbedömning',

   // Module types
   GeneralModule: 'Allmän modul',
   DemandComplianceModule: 'Kravefterlevnadsmodul',
   RiskManagementModule: 'Riskhanteringsmodul',
   Component: 'Grundmoduler',

   // Demand compliance modules
   WORK_ENVIRONMENT: 'Arbetsmiljö',
   GDPR: 'GDPR',
   ISO27001: 'ISO 27 001',
   ISO28000: 'ISO 28 000',
   ISO31000: 'ISO 31 000',
   ISO45000: 'ISO 45 000',
   SSF_CYBER_SECURITY: 'SSF Cybersäkerhet',
   SYSTEMATIC_FIRE_PROTECTION_WORK: 'Systematiskt brandskyddsarbete',
   SECURITY_PROTECTION: 'Säkerhetsskydd',
   LAW_FIRM: 'Advokatbyrå',
   TECHNICAL_INSTALLERS: 'Tekniska installatörer',
   TECHNICAL_CONSULTANTS: 'Tekniska konsulter',
   FR20002022BUSINESSMANAGEMENT: 'FR2000:2022 verksamhetsledning',

   // Subscriptions
   DEMO: 'Demo',
   STRATEGIC_DEMAND_ASSESSMENT: 'Strategisk kravbedömning',
   MANAGEMENT: 'Ledningsgrupp',
   LINE_MANAGER: 'Linjechef',
   SPECIALIST: 'Specialist',
   CONSULTANT: 'Konsult',
   ADD_ON: 'Tillägg',

   // Risk management modules
   SWOT_ANALYSIS: 'SWOT-analys',
   SIMPLIFIED_RISK_ANALYSIS: 'Förenklad riskanalys',
   CONSEQUENCE_AND_PROBABILITY_ANALYSIS: 'Konsekvens- & sannolikhetsanalys',

   // General modules
   WORD_LIST: 'Ordlista',
   INCIDENT_REPORT: 'Händeserapportering',
   WHISTLE_BLOWER: 'Visselblåsning',
   INSURANCE_REGISTER: 'Försäkringsregister',
   PHYSICAL_PLANNING: 'Fysisk planering',
   SECURITY_SYSTEM: 'Säkerhetssystem',
   ROBUSTER: 'Robuster',
   CORPORATE_GROUP: 'Koncern',
   CONTRACT_REGISTER: 'Avtalsregister',
   SELF_AUDIT: 'Egenkontroll och revision',
   SECURITY_ADMINISTRATION: 'Säkerhetsadministration',
   PERSONNEL_ANALYSIS: 'Personalanalys',
   EXPORT_MODULE: 'Exportmodul',
   IMPORT_MODULE: 'Importmodul',
   STATISTICS: 'Statistik',
   SAFETY_GUIDE: 'Säkerhetshandbok',

   // Components
   CALENDAR: 'Kalender',
   RISK_ECONOMY: 'Riskekonomi',
   RISK_MANAGEMENT: 'Riskhantering',
   DEMAND_COMPLIANCE: 'Kravefterlevnad',

   //Roles
   SystemAdministrator: 'Systemadministratör',

   // Cache
   Maintenance: 'Underhåll',
   RefreshCache: 'Uppdatera cache',
   RefreshCacheDescription: 'Tvingar kundappen att hämta om alla frågor, krav och svaralternativ från backoffice. Används efter att ändringar publicerats.',
   RefreshCacheSuccess: 'Cachen har uppdaterats. Kundappen hämtar ny data vid nästa förfrågan.',
   RefreshCacheFailed: 'Det gick inte att uppdatera cachen. Försök igen eller starta om kundappens API.',
}
